import { observable } from 'mobx'
import React from 'react'

const yEdgeCases = new Set(['day'])

class I18n {
  @observable language = ''
  languages: Record<string, Record<string, string>> = {}

  constructor(languages: Record<string, Record<string, string>>, language: string) {
    this.languages = languages
    this.language = language
  }

  setLanguage(language: string) {
    this.language = language
  }

  get currentLanguage() {
    return this.languages[this.language]
  }

  // Method to translate string
  s = (string: string, arg0?: string | number | null, arg1?: string | number | null, arg2?: string | number | null) => {
    // Create lowercase version
    const stringL = string.toLowerCase()

    // Match on string, lowercased string or return initial string passed in
    let str = this.currentLanguage![string] || this.currentLanguage![stringL] || string

    // Do templating
    if (arg0 !== undefined) {
      str = str.replace(/\$0/g, `${arg0}`)
    }

    if (arg1 !== undefined) {
      str = str.replace(/\$1/g, `${arg1}`)
    }

    if (arg2 !== undefined) {
      str = str.replace(/\$2/g, `${arg2}`)
    }

    return str
  }

  pluralise = (string: string, count = 0) => {
    const i18nString = this.s(string)

    if (count === 1) return i18nString

    // For english
    const lastLetter = i18nString.charAt(i18nString.length - 1)
    if (lastLetter === 'y') {
      // y edge cases 
      if (yEdgeCases.has(i18nString.toLocaleLowerCase())) {
        return i18nString + 's'
      }

      return i18nString.slice(0, i18nString.length - 1) + 'ies'
    }
    if (lastLetter === 's') return i18nString + 'es'

    return i18nString + 's'
  }
}

export type $i18n = I18n
export default I18n

export const I18nContext = React.createContext({} as I18n)

export const useI18n = () => {
  const i18n = React.useContext(I18nContext)
  if (!i18n) {
    // this is especially useful in TypeScript so you don't need to be checking for null all the time
    throw new Error('i18n must be used within a I18nContext.')
  }
  return i18n
}